export const baseEventWidth = 200;
export const baseEventHeight = 50;

export const baseHouseHeight = (bedsCount, eventNodesCount) => {
  if (bedsCount === 1) {
    return 120;
  } else if (bedsCount === 2) {
    return 210;
  } else if (bedsCount === 3) {
    return 305;
  } else if (bedsCount === 4) {
    return eventNodesCount > 3 ? 400 : 350;
  } else if (bedsCount >= 5) {
    const baseHeight = 350 + (bedsCount - 4) * 40; // Bazowa wysokość dla 5,6,7 itd.
    const extraHeight = eventNodesCount > 3 ? (eventNodesCount - 3) * 55 : 0;

    return baseHeight + extraHeight;
  }

  return 0;
};
